import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import styled from "styled-components";
import { useNavigate } from "react-router";
import Buttons from "../../components/atoms/Buttons";
import { StatusType } from "../../components/atoms/Explain/types";
import { ReactComponent as Tirepicklogo } from "../../assets/icons/TirepickLogo.svg";
import TextInputs from "../../components/atoms/Inputs/TextInputs";
import Label from "../../components/atoms/Label";
import { ALERT_MESSAGE, PLACEHOLDER } from "../../components/constants";
import PhoneInput from "../../components/molecures/PhoneInput";
import { theme } from "../../theme";

import { VerifyPhoneRequest } from "../../apis/PwdReset/apis/types";
import { resetPass, verifyPhone } from "../../apis/PwdReset/apis";
import {
  alertError,
  alertSuccess,
  validatePass,
  validatePhone,
} from "../../shared/utils";
import { HttpError } from "../../network/types";
import ExplainWrapper from "../../components/molecures/ExplainWrapper";
import { PATH } from "../../routes/constants/path";

const PwdReset: React.FC = () => {
  const nav = useNavigate();
  const [verifyForm, setVerifyForm] = useState<VerifyPhoneRequest>({
    repairShopAId: "",
    managerPhone: "",
    authTokenId: "",
    accessToken: "",
    newPass: "",
    repairShopId: undefined,
  });
  const VerifyPhoneMutation = useMutation(verifyPhone, {
    onSuccess: (res) => {
      setVerifyForm({ ...verifyForm, repairShopId: res.id });
      setAllPass(true);
    },
    onError: (err: HttpError) => {
      setVerifyForm({ ...verifyForm, accessToken: "" });
      setStatus({
        ...status,
        aId: { status: "error", explain: err.message },
      });
    },
  });
  const ResetPassMutation = useMutation(resetPass, {
    onSuccess: () => {
      alertSuccess("비밀번호 변경이 성공하였습니다");
      nav(PATH.LOGIN);
    },
    onError: (err) => {
      alertError(get(err, "message"));
    },
  });
  const [status, setStatus] = useState<{
    aId: { status?: StatusType; explain?: string };
    phone?: { status?: StatusType; explain?: string };
    auth?: { status?: StatusType; explain?: string };
    pass?: { status?: StatusType; explain?: string };
    rePass?: { status?: StatusType; explain?: string };
  }>({
    aId: { status: undefined, explain: undefined },
    phone: { status: undefined, explain: undefined },
    auth: { status: undefined, explain: undefined },
    pass: { status: undefined, explain: undefined },
    rePass: { status: undefined, explain: undefined },
  });
  const [authTokenId, setAuthTokenId] = useState("");
  const [authNum, setAuthNum] = useState("");
  const [rePass, setRepass] = useState("");
  const [isAllPass, setAllPass] = useState(false);
  useEffect(() => {
    const passMessages = validatePass(verifyForm.newPass);
    if (rePass !== verifyForm.newPass) {
      setStatus({
        ...status,
        pass: {
          status:
            verifyForm.newPass.length === 0
              ? undefined
              : passMessages.length === 0
              ? undefined
              : "error",
          explain:
            verifyForm.newPass.length === 0
              ? undefined
              : passMessages.length === 0
              ? undefined
              : passMessages.join(" "),
        },
      });
    }
  }, [verifyForm.newPass, rePass]);

  return (
    <>
      <StyledHeader>
        <LogoWrapper
          onClick={() => {
            nav(PATH.LOGIN);
          }}
        >
          <Tirepicklogo />
        </LogoWrapper>
      </StyledHeader>
      {!isAllPass ? (
        <StyledPageContainer>
          <StyledResetFormWrapper>
            <StyledInputWrapper>
              <StyledTitle>비밀번호 재설정</StyledTitle>
            </StyledInputWrapper>
            <StyledInputWrapper>
              <Label isRequired>아이디</Label>
              <ExplainWrapper status={status.aId}>
                <TextInputs
                  placeholder={PLACEHOLDER.ID}
                  isNotBordered
                  value={verifyForm.repairShopAId}
                  onChange={(e) => {
                    setVerifyForm({
                      ...verifyForm,
                      repairShopAId: e,
                      accessToken: "",
                      authTokenId: "",
                    });
                    setStatus({
                      ...status,
                      aId: { status: undefined, explain: undefined },
                    });
                  }}
                  status={status.aId.status}
                />
              </ExplainWrapper>
            </StyledInputWrapper>
            <PhoneInput
              repairShopAId={verifyForm.repairShopAId}
              onSendPhone={({ authTokenId = "" }) => {
                setAuthTokenId(authTokenId);
              }}
              onVerifyAuth={({ accessToken = "" }) => {
                setVerifyForm({ ...verifyForm, accessToken });
              }}
              disabled={
                !verifyForm.repairShopAId || verifyForm.accessToken !== ""
              }
              phoneValue={verifyForm.managerPhone}
              authNumValue={authNum}
              onChangePhone={(e) => {
                setVerifyForm({
                  ...verifyForm,
                  managerPhone: e,
                  accessToken: "",
                  authTokenId: "",
                });
                if (validatePhone(e) === false) {
                  setStatus({
                    ...status,
                    phone: {
                      status: "error",
                      explain: ALERT_MESSAGE.WRONG_PHONE,
                    },
                  });
                } else {
                  setStatus({
                    ...status,
                    phone: {
                      status: undefined,
                      explain: undefined,
                    },
                  });
                }
                if (e === "")
                  setStatus({
                    ...status,
                    phone: {
                      status: undefined,
                      explain: undefined,
                    },
                  });
              }}
              onChangeAuth={(e) => {
                setAuthNum(e);
              }}
            />
            <StyledInputWrapper>
              <StyledBtnWrapper>
                <Buttons
                  disabled={verifyForm.accessToken === ""}
                  size="block"
                  text="확인"
                  onClick={() => {
                    VerifyPhoneMutation.mutate({ ...verifyForm, authTokenId });
                  }}
                />
              </StyledBtnWrapper>
            </StyledInputWrapper>
          </StyledResetFormWrapper>
        </StyledPageContainer>
      ) : (
        <StyledPageContainer>
          <StyledResetFormWrapper>
            <StyledInputWrapper>
              <StyledTitle>비밀번호 재설정</StyledTitle>
            </StyledInputWrapper>
            <StyledInputWrapper>
              <Label isRequired>새 비밀번호</Label>
              <TextInputs
                isNotBordered
                isPassword
                placeholder={PLACEHOLDER.PASS}
                value={verifyForm.newPass}
                onChange={(e) => {
                  setVerifyForm({ ...verifyForm, newPass: e });
                  setStatus({
                    ...status,
                    rePass: {
                      status: e !== rePass ? "error" : undefined,
                      explain:
                        e !== rePass ? ALERT_MESSAGE.INVALID_REPASS : undefined,
                    },
                    pass: { status: undefined, explain: undefined },
                  });
                }}
                status={status.pass?.status}
                explain={status.pass?.explain}
              />
            </StyledInputWrapper>
            <StyledInputWrapper>
              <Label isRequired>비밀번호 확인</Label>
              <TextInputs
                placeholder={PLACEHOLDER.REPASS}
                isNotBordered
                isPassword
                value={rePass}
                onChange={(e) => {
                  if (rePass.length > 0)
                    setStatus({
                      ...status,
                      rePass: {
                        status: verifyForm.newPass !== e ? "error" : undefined,
                        explain:
                          verifyForm.newPass !== e
                            ? ALERT_MESSAGE.INVALID_REPASS
                            : undefined,
                      },
                    });
                  setRepass(e);
                }}
                status={status.rePass?.status}
                explain={status.rePass?.explain}
              />
            </StyledInputWrapper>
            <StyledInputWrapper>
              <StyledBtnWrapper>
                <Buttons
                  size="block"
                  onClick={() => {
                    ResetPassMutation.mutate({
                      newPass: verifyForm.newPass,
                      accessToken: verifyForm.accessToken,
                      authTokenId: authTokenId || verifyForm.authTokenId,
                      repairShopId: verifyForm.repairShopId || -1,
                    });
                  }}
                  disabled={
                    rePass !== verifyForm.newPass ||
                    validatePass(verifyForm.newPass).length !== 0
                  }
                  text="비밀번호 재설정"
                />
              </StyledBtnWrapper>
            </StyledInputWrapper>
          </StyledResetFormWrapper>
        </StyledPageContainer>
      )}
    </>
  );
};

export default PwdReset;
const StyledPageContainer = styled.section`
  background-color: ${theme.colors.white};
  display: flex;
  min-height: 100vh;
  justify-content: center;
`;
const StyledResetFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 320px;
  max-width: 320px;
`;
const StyledInputWrapper = styled.div`
  min-width: 320px;
  max-width: 320px;
  margin-bottom: 60px;
`;
const StyledTitle = styled.div`
  ${theme.typo.title.t32};
`;

const StyledBtnWrapper = styled.div`
  height: 54px;
`;
const StyledHeader = styled.div`
  height: 56px;
  background: ${theme.colors.white};
  position: fixed;
  top: 0px;
  width: 100%;
  padding: 18px 60px;
  box-shadow: inset 0px -1px 0px #dcdcdc;
`;
const LogoWrapper = styled.div`
  cursor: pointer;
`;
